<div class="container-fluid widget-wrapper">
  <div class="row widget-header" #widgetHeader [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Viewability</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon" data-placement="top" data-toggle="tooltip" enTooltip title="The average viewability, according the IAB standard of 50% in view for at least 1 second, for display advertisements in the app.">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon"/>
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-viewability [data]="data" [isFreemium]="isFreemium"></app-viewability>
    </div>
  </div>
</div>
